import React from 'react';
import { useLanguage } from '../utils/useLanguage';

const AGE_GROUPS = [
  { value: '1-3', label_de: '1–3', label_en: '1–3' },
  { value: '4-6', label_de: '4–6', label_en: '4–6' },
  { value: '7-11', label_de: '7–11', label_en: '7–11' },
  { value: '12-16', label_de: '12–16', label_en: '12–16' },
];

export default function ArticleFilters({ topics, selectedTopic, selectedAges, onTopicChange, onAgeToggle, onReset }) {
  const { language, t } = useLanguage();

  return (
    <div>
      <div className="container mx-auto px-3 sm:px-4 pb-8">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-gray-400 mr-1">{t('Thema', 'Topic')}:</span>
          <button
            onClick={() => onTopicChange(null)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              !selectedTopic ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {t('Alle', 'All')}
          </button>
          {topics.map(topic => (
            <button
              key={topic.id}
              onClick={() => onTopicChange(topic.id)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                selectedTopic === topic.id ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {language === 'en' ? topic.name_en || topic.name_de : topic.name_de}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2 flex-wrap mt-3">
          <span className="text-sm font-medium text-gray-400 mr-1">{t('Alter', 'Age')}:</span>
          {AGE_GROUPS.map(age => {
            const active = selectedAges.includes(age.value);
            return (
              <button
                key={age.value}
                onClick={() => onAgeToggle(age.value)}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                  active ? 'bg-emerald-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {language === 'en' ? age.label_en : age.label_de}
              </button>
            );
          })}
          {(selectedTopic || selectedAges.length > 0) && (
            <button
              onClick={onReset}
              className="ml-auto text-sm text-gray-400 hover:text-gray-600 underline"
            >
              {t('Filter zurücksetzen', 'Reset filters')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}